export default __webpack_public_path__ + "static/media/0070.edaee668.jpg";